"use strict";

exports.__esModule = true;
exports.CalendarEditor = void 0;
var _core = require("@blueprintjs/core");
var _luxon = require("luxon");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _icons = require("@blueprintjs/icons");
var _libCalendar = require("@vimana/lib-calendar");
var _UI = require("../../../Utils/UI");
var _Core = require("../../Core");
var _Theme = require("../../Theme");
var _CalendarContext = require("../CalendarContext");
var _CalendarEventEditor = require("../CalendarEventEditor/CalendarEventEditor");
var _PlantCalendar = require("../PlantCalendar");
var _excluded = ["translator", "calendar", "canEdit"];
var _dec, _class, _CalendarEditor;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var CalendarRow = _styledComponents["default"].div.withConfig({
  displayName: "CalendarEditor__CalendarRow",
  componentId: "sc-iocck1-0"
})(["display:flex;flex:1;overflow:auto;"]);
var CalendarWrapper = _styledComponents["default"].div.withConfig({
  displayName: "CalendarEditor__CalendarWrapper",
  componentId: "sc-iocck1-1"
})(["flex-grow:1;"]);
var CalendarSidebar = _styledComponents["default"].div.withConfig({
  displayName: "CalendarEditor__CalendarSidebar",
  componentId: "sc-iocck1-2"
})(["display:flex;flex-basis:400px;border-left:1px solid rgba(0,0,0,0.2);padding:1rem;position:relative;background:", ";height:calc(100vh - 200px);overflow-y:auto;"], (0, _Theme.val)("background"));
var CalendarSidebarCloseButton = _styledComponents["default"].div.withConfig({
  displayName: "CalendarEditor__CalendarSidebarCloseButton",
  componentId: "sc-iocck1-3"
})(["background:none;border:none;cursor:pointer;position:absolute;top:0.5rem;right:0.5rem;"]);
var CalendarEditor = exports.CalendarEditor = (_dec = _CalendarContext.CalendarContext.withContext, _dec(_class = (0, _Core.withTranslator)(_class = (_CalendarEditor = /*#__PURE__*/function (_Component) {
  function CalendarEditor() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      selectedEvent: undefined,
      selectedEventConfig: undefined,
      selectedAgenda: undefined,
      selectedSchedule: undefined
    };
    _this.handleSelectEvent = function (selectedEvent) {
      var calendar = _this.props.calendar.calendar;
      var selectedEventConfig = calendar.getEventConfigByID(selectedEvent.sourceId);
      var selectedAgenda = calendar.getAgendaByEventConfigID(selectedEvent.sourceId);
      var agendaId = selectedAgenda && selectedAgenda.id;
      var selectedSchedule = agendaId ? calendar.getScheduleByAgendaID(agendaId) : undefined;
      _this.setState({
        selectedEvent: selectedEvent,
        selectedEventConfig: selectedEventConfig,
        selectedAgenda: selectedAgenda,
        selectedSchedule: selectedSchedule
      });
    };
    _this.handleSelectSlot = function (_ref) {
      var start = _ref.start,
        end = _ref.end;
      if (!_this.props.canEdit) {
        return;
      }
      var event = {
        type: "Holiday",
        payload: {
          name: ""
        },
        interval: {
          startMillis: start.valueOf(),
          endMillis: end.valueOf()
        }
      };
      _this.setState({
        selectedEvent: event,
        selectedAgenda: undefined,
        selectedSchedule: undefined,
        selectedEventConfig: undefined
      });
    };
    _this.handleSubmit = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
        var actions, id;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (_this.props.canEdit) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              actions = _this.props.calendar.actions;
              id = event.id;
              if (id) {
                _context.n = 3;
                break;
              }
              _context.n = 2;
              return actions.createCalendarEvent(event);
            case 2:
              _context.n = 4;
              break;
            case 3:
              _context.n = 4;
              return actions.updateCalendarEvent(id, event);
            case 4:
              actions.refresh();
            case 5:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    _this.handleDelete = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(id) {
        var translator;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (_this.props.canEdit) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              translator = _this.props.translator;
              (0, _UI.showWarningToaster)(translator.translate("Calender.Editor.ConfirmTest", "Are you sure you want to delete this event?"), {
                onClick: function () {
                  var _onClick = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                    var actions;
                    return _regenerator().w(function (_context2) {
                      while (1) switch (_context2.n) {
                        case 0:
                          actions = _this.props.calendar.actions;
                          _context2.n = 1;
                          return actions.deleteCalendarEvent(id);
                        case 1:
                          actions.refresh();
                        case 2:
                          return _context2.a(2);
                      }
                    }, _callee2);
                  }));
                  function onClick() {
                    return _onClick.apply(this, arguments);
                  }
                  return onClick;
                }(),
                text: translator.translate("Calender.Editor.ConfirmButton", "Yes")
              });
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }();
    _this.handleCloseSidebar = function () {
      _this.setState({
        selectedEvent: undefined,
        selectedEventConfig: undefined,
        selectedAgenda: undefined,
        selectedSchedule: undefined
      });
    };
    return _this;
  }
  _inheritsLoose(CalendarEditor, _Component);
  var _proto = CalendarEditor.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      translator = _this$props.translator,
      calendar = _this$props.calendar.calendar,
      canEdit = _this$props.canEdit,
      props = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var _this$state = this.state,
      selectedEvent = _this$state.selectedEvent,
      selectedEventConfig = _this$state.selectedEventConfig,
      selectedAgenda = _this$state.selectedAgenda,
      selectedSchedule = _this$state.selectedSchedule;
    if (calendar.schedules.length === 0) {
      return /*#__PURE__*/_react["default"].createElement(_core.NonIdealState, {
        visual: "calendar",
        title: translator.translate("CalendarEditor.nonIdealState.title", "No schedules defined for this plant."),
        action: /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
          "data-testid": "CalendarEditor",
          icon: _icons.IconNames.ADD,
          to: "/calendar/create-schedule",
          text: translator.translate("CalenderEditor.nonIdealState.createNewSchedule", "Create a new Schedule")
        })
      });
    }
    var localTime = _luxon.DateTime.local();
    return /*#__PURE__*/_react["default"].createElement(CalendarRow, {
      "data-testid": "CalendarEditor"
    }, /*#__PURE__*/_react["default"].createElement(CalendarWrapper, null, /*#__PURE__*/_react["default"].createElement(_PlantCalendar.PlantCalendar, _extends({
      calendar: new _libCalendar.Calendar(Object.assign({}, calendar.toJSON(), {
        timezone: {
          name: localTime.zoneName,
          currentOffsetMillis: localTime.offset * 60000
        }
      })),
      onSelectEvent: this.handleSelectEvent,
      selectable: true,
      onSelectSlot: this.handleSelectSlot
    }, props))), canEdit && selectedEvent && /*#__PURE__*/_react["default"].createElement(CalendarSidebar, null, /*#__PURE__*/_react["default"].createElement(CalendarSidebarCloseButton, {
      onClick: this.handleCloseSidebar
    }, /*#__PURE__*/_react["default"].createElement(_core.Icon, {
      icon: "cross"
    })), /*#__PURE__*/_react["default"].createElement(_CalendarEventEditor.CalendarEventEditor, {
      event: selectedEvent,
      config: selectedEventConfig,
      agenda: selectedAgenda,
      schedule: selectedSchedule,
      onSubmit: this.handleSubmit,
      onDelete: this.handleDelete,
      onCancel: this.handleCloseSidebar
    })));
  };
  return CalendarEditor;
}(_react.Component), _CalendarEditor.defaultProps = {
  translator: undefined,
  calendar: undefined
}, _CalendarEditor)) || _class) || _class);